export const INCOGNITO_COOKIE = 'KhryuS3bST';
export const INCOGNITO_COOKIE_VALUE = 'fjVVeSz4QT';
export const LOGOUT_COOKIE = 'sUkKxec3ld';
export const LOGOUT_COOKIE_VALUE = 'C0yw20eSw4';
export const USER_ID_COOKIE = 'uPruEGemmc';
export const CLARITY_COOKIE = '_clck';
